import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerOutputDataGeneratorRequest = {
	triggerFilters?: string[]
}

export const triggerOutputDataGenerator = createAppAsyncThunk<void, TriggerOutputDataGeneratorRequest>(
	"formStep/triggerOutputDataGenerator",
	async ({ triggerFilters = [] }, { getState, extra, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;
			if (!selectedEtlImportUuid) return;

			await extra.etlClient.trigger(EtlApiTarget.GENERATE_OUTPUT_DATA_API, selectedEtlImportUuid, { triggerFilters })
			dispatch(postToast({ message: "Données d'export générées avec succès", type: ToastType.SUCCESS }))


		} catch (error: any) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	},
	{
		condition: (_, { getState }) => {
			if (getState().formStep.preProcessRunning) return false;
		}
	}
);
